module.exports = __webpack_public_path__ + "img/portal-mark.78e6ea87.svg";